import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { DisabledProfilingMenu } from 'shell/view-models/disabled-menu';
import { useRouteAuthorization } from 'shell/hooks/use-route-authorization';
import { systemRoutes } from 'system/router/routing-config';

interface AmministrationMenuProps {
  visibility?: DisabledProfilingMenu;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const AmministrationMenu = ({
  visibility = {
    group: true,
    profile: true,
    featureAuthValue: true,
    featureAuth: true,
    numerator: true,
  },
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: AmministrationMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  const items = useRouteAuthorization(systemRoutes[0].children[0].children);
  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Tabelle di Amministrazione" />
      </ListItem>
      <Menu
        id="AmministrationMenu-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        {items
          .filter((route) => !route.hidden)
          .map((systemRoute) => (
            <div key={systemRoute.path}>
              <MenuItem
                onClick={(event: MouseEvent) => {
                  onClose(event);
                  navigate(`/sistema/${systemRoute.path}` || '');
                }}
              >
                <Typography variant="inherit">{systemRoute.name}</Typography>
              </MenuItem>
              <Divider key={systemRoute.name} />
            </div>
          ))}
        {visibility.group
          ? [
              <MenuItem
                onClick={(event: MouseEvent) => {
                  onClose(event);
                  navigate('/sistema/gruppi');
                }}
                key="groups-menu-item"
              >
                <Typography variant="inherit">Gruppi</Typography>
              </MenuItem>,
              <Divider key="groups-divider" hidden={!visibility.group} />,
            ]
          : undefined}
        {visibility.profile
          ? [
              <MenuItem
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/profili');
                }}
                key="profile-menu-item"
              >
                <Typography variant="inherit">Profili</Typography>
              </MenuItem>,
              <Divider key="profile-divider" hidden={!visibility.group && !visibility.profile} />,
            ]
          : undefined}
        {visibility.group && visibility.profile
          ? [
              <MenuItem
                onClick={(event: MouseEvent) => {
                  onClose(event);
                  navigate('/sistema/funzioni');
                }}
                key="functions-menu-item"
              >
                <Typography variant="inherit">Funzioni</Typography>
              </MenuItem>,
              <Divider key="function-divider" hidden={!visibility.featureAuth} />,
            ]
          : undefined}
        {visibility.featureAuth
          ? [
              <MenuItem
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/feature-auth');
                }}
                key="feature-auth-menu-item"
              >
                <Typography variant="inherit">Autorizzazioni</Typography>
              </MenuItem>,
              <Divider key="feature-auth-divider" hidden={!visibility.numerator} />,
            ]
          : undefined}
        {/* {visibility.featureAuthValue
          ? [
              <MenuItem
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/feature-valore');
                }}
                key="feature-auth-value-menu-item"
              >
                <Typography variant="inherit">Feature auth valore</Typography>
              </MenuItem>,
            ]
          : undefined} */}
        {visibility.numerator
          ? [
              <MenuItem
                onClick={(event: MouseEvent) => {
                  onClose(event);
                  navigate('/sistema/numeratori');
                }}
                key="numerators-menu-item"
              >
                <Typography variant="inherit">Numeratori</Typography>
              </MenuItem>,
            ]
          : undefined}
      </Menu>
    </Fragment>
  );
};

AmministrationMenu.displayName = 'Profiling Menu';

export default AmministrationMenu;
